<template>
    <v-form
        v-model="valid"
        ref="form"
        :disabled="props.disabled || isSubmitting"
        :readonly="readonlyFields"
        >
        <!-- <h1 class="mt-4">{{ resolvedQuestionaireTypeTitle }}</h1> -->
        <h2 class="ms-4 mt-2 mb-8">{{ resolvedAssessmentTargetName }}</h2>
        <v-row 
            class="ma-0 justify-space-between  
             pt-6 pb-4 mb-4 " 
            :class="[
                props.standalone 
                    ? 'position-sticky top-0 bg-background border-b-lg border-primary' 
                    : '',
            ]"
            style="z-index:1">
            <v-col class="pa-0" cols="12" md="4">
                <v-select 
                    v-model="formValues.type" 
                    label="Tipo de avaliação:" 
                    variant="outlined"
                    :items="evaluationTypesList"
                    item-title="label"
                    item-value="key"
                    :clearable="!props.assessmentType"
                    :menu-icon="!props.assessmentType ? undefined : ''"
                    :readonly="!!props.assessmentType || readonlyFields"
                    :loding="isLoadingAssessmentModel"
                    :disabled="props.disabled || isLoadingAssessmentModel || isSubmitting"
                    :rules="[
                        formValidationRules.required(formValues.type)
                    ]"
                ></v-select>
            </v-col>
            <v-col class="py-0 px-4" cols="12" md="4">
                <v-select
                    v-model="formValues.year"
                    label="Ano da avaliação:"
                    variant="outlined"
                    :items="[...Array(new Date().getFullYear() + 1 ).keys()].slice(2000).reverse()"
                    :clearable="!props.assessmentType"
                    :menu-icon="!props.assessmentType ? undefined : ''"
                    :readonly="!!props.assessmentType || readonlyFields"
                    :loding="isLoadingAssessmentModel"
                    :disabled="props.disabled || isLoadingAssessmentModel || isSubmitting"
                    :rules="[
                        formValidationRules.required(formValues.type)
                    ]"
                />
            </v-col>
            <v-col class="pa-0" cols="12" md="4">
                <v-autocomplete 
                    v-model="formValues.subject_user_id" 
                    label="Colaborador(a):" 
                    variant="outlined" 
                    :items="usersList" 
                    item-value="id" 
                    item-title="name"
                    
                    :clearable="!props.assessmentType"
                    :menu-icon="!props.assessmentType ? undefined : ''"
                    :readonly="!!props.assessmentType || readonlyFields"
                    :loding="isLoadingAssessmentModel"
                    :disabled="props.disabled || isLoadingAssessmentModel || isSubmitting"
                    :rules="[
                        formValidationRules.required(formValues.type)
                    ]"
                />
            </v-col>
            <v-alert
                v-if="alertInfo.type && alertInfo.type !== 'error'"
                :color="alertInfo.type ?? 'error'"
                :title="alertInfo.title"
                :text="alertInfo.text"
                closable
                :variant="alertInfo.variant ?? 'tonal'"
                class="mt-4"
            />
        </v-row>
        <fieldset
            v-for="(section, index) in questionnaireSections"
            :key="index"
            class="border-0"
        >
            <legend 
                class="text-h5 w-100"
                :class="[
                    props.standalone
                        ? ''
                        : 'position-sticky bg-surface',

                ]"
                style="z-index: 2; top: -0.75em"
            >{{ section.title }}</legend>
            <v-skeleton-loader
                v-if="isLoadingAssessmentModel || isLoadingRatingOptions"
                type="article@3"
                :color="props.standalone ? 'background' : undefined"
            ></v-skeleton-loader>
            <div v-else>
                <v-row 
                    v-for="competency in section.competencies"
                    :key="competency.id"
                    class="ma-0 mt-4 mb-8"
                >
                    <!-- Competency name / title / description -->
                    <fieldset class="border-0">
                        <legend
                            class="text-h6 mb-6 py-5 w-100"
                            :class="[
                                props.standalone
                                    ? ''
                                    : 'position-sticky bg-surface',

                            ]"
                            style="z-index: 1;top: 0.25em"
                        >{{ competency?.name }}</legend>
                        <v-row 
                            v-for="(compIndicator, indicatorIndex) in competency?.indicators"
                            :key="compIndicator.id"
                            class="ma-0"
                        >
                            
                            <v-col class="pa-0" cols="12">
                                <p>{{ 
                                    compIndicator.description 
                                    ?? compIndicator.name 
                                    ?? compIndicator.title 
                                    ?? 'Indicador sem descrição!' 
                                }}</p>
                                <div class="d-flex align-center">

                                    <v-checkbox 
                                    v-if="section?.supportsNotApplicable" 
                                    v-model="
                                        formValues
                                        .answers
                                        [answerKey(section, compIndicator)]
                                        .is_not_applicable
                                    "
                                    label="Não aplicável" 
                                    class="me-4"
                                    @update:model-value="() => formValues
                                        .answers
                                        [answerKey(section, compIndicator)]
                                        [section.valueField] = null "
                                    :disabled="isSubmitting "
                                    :readonly="readonlyFields"
                                ></v-checkbox>
                                <v-radio-group 
                                    v-model="
                                        formValues.answers[answerKey(section, compIndicator)][section.valueField]
                                    "
                                    inline 
                                    :class="[
                                        'indicator-rating-group-option',
                                        '',
                                        !formValues.answers[answerKey(section, compIndicator)].is_not_applicable
                                            ? 'enabled'
                                            : ''
                                        ,
                                    ]"
                                    :rules="[
                                        formValidationRules.requiredIfAll(
                                            formValues.answers[answerKey(section, compIndicator)][section.valueField],
                                            [
                                                validationMode !== 'draft',
                                                !formValues.answers[answerKey(section, compIndicator)].is_not_applicable
                                            ]
                                        )
                                    ]"
                                    :disabled="isSubmitting"
                                    :readonly="readonlyFields"
                                >
                                    
                                    <v-radio
                                        v-for="(rating, ratingIndex) in ratingOptions"
                                        :key="`${compIndicator.id}__${rating.id}`"
                                        :label="rating?.name ?? rating?.description ?? 'Opção sem nome'"
                                        :value="rating[section.ratingValueField]"
                                        :disabled="
                                            formValues.answers[
                                                answerKey(section, compIndicator)
                                            ].is_not_applicable
                                            || isSubmitting
                                        "
                                        :readonly="readonlyFields"
                                    >
        
                                    </v-radio>
                                </v-radio-group>
                                </div>
                            </v-col>
                        </v-row>
                        <!-- v-for competency indicators -->
                    </fieldset>
                    <!-- indicator answers -->
                </v-row>
                
            </div>
        </fieldset>
        <v-row 
            class="ma-0 py-4 " 
            :class="[
                props.standalone
                    ? 'position-sticky bottom-0 bg-background border-t-lg border-t-primary'
                    : '',
            ]"
        >
            <v-alert
                v-if="alertInfo.type && alertInfo.type === 'error'"
                :color="'error'"
                :title="alertInfo.title"
                :text="alertInfo.text"
                closable
                variant="tonal"
                class="mb-4"
            />
            <v-col 
                v-if="(props.standalone && !readonlyFields)"
                class="pa-0 d-flex justify-end ga-6" 
                cols="12"
            >
                <v-btn 
                    class="text-none" 
                    variant="outlined" 
                    color="success" 
                    :prepend-icon="
                        isSubmitting && validationMode !== 'draft'
                        ? 'mdi-loading mdi-spin'
                        : 'mdi-send-lock'
                    "
                    @click="submit('final')"
                    :disabled="isSubmitting"
                >
                    {{
                        isSubmitting && validationMode !== 'draft'
                        ? 'Submetendo...'
                        : 'Submeter (e trancar)'
                    }}
                </v-btn>
                <v-btn 
                    class="text-none" 
                    :prepend-icon="
                        isSubmitting && validationMode === 'draft'
                        ? 'mdi-loading mdi-spin'
                        : 'mdi-content-save'
                    " 
                    color="success" 
                    variant="flat"
                    @click="submit()"
                    :disabled="isSubmitting"
                >
                    {{
                        isSubmitting && validationMode === 'draft'
                        ? 'Guardando...'
                        : 'Guardar rascunho'
                    }}
                </v-btn>
            </v-col>
        
        </v-row>

    </v-form>
</template>
<script setup>

import {  ref, computed, onMounted, onBeforeMount, nextTick } from 'vue';
import SelfAssessmentQuestionaires from "@/api/assessments/questionaires/SelfAssessmentQuestionaires.js"
import AscendingAssessmentQuestionaires from "@/api/assessments/questionaires/AscendingAssessmentQuestionaires.js"
import DownwardAssessmentQuestionaires from "@/api/assessments/questionaires/DownwardAssessmentQuestionaires.js"
import formValidationRules from '@/composables/formValidationRules';

import { useSessionStore } from '@/stores/SessionStore';
import AssessmentModels from '../../../api/assessments/models/AssessmentModels';


const props = defineProps({
    assessmentType: {
        type: String,
        required: true,
        validator: (value, props) => {
            return ["self", "ascending", "downward"].includes(value);
        },
    },
    action: {
        type: String,
        default: "new",
        validator: (value, props) => {
            return [
                "create", 
                "new", 
                "edit", 
                "update", 
                "read",
                "get",
                "submit"
            ].includes(value)
        },
    },
    assessmentModel : {
        type: Object,
        default: null,
    },
    assessmentId : {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    readonly : {
        type: Boolean,
        default: false,
    },
    standalone: {
        type: Boolean,
        default: false,
    },
});

defineExpose({
    validate,
    submit,
    submitFromDialog
});



const sessionStore = useSessionStore();
const isLoadingAssessmentModel = ref(false);
const isLoadingTechnicalCompetencies = ref(false);
const isLoadingPersonalCompetencies = ref(false);
const isLoadingObjectivesCompetencies = ref(false);
const isSubmitting = ref(false);
const valid = ref(false);
const form = ref(null);
const questionaire = ref({});
const readonlyFields = computed(() => {
    return props.readonly 
            || ["read", "get"].includes(props.action)
            || !questionaire.value?.can_update 
            || questionaire.value?.status === "submitted"
});
const ratingOptions = ref([]);
const isLoadingRatingOptions = ref(false);
const validationMode = ref(
    ["submit", "lock"].includes(props?.action)
    ? "final"
    : "draft"
);

const alertInfo = ref({
    type: null,
    title: null,
    text: null,
})

const resolvedAssessmentApi = computed(() => {
    switch (props.assessmentType) {
        case "self":
            return SelfAssessmentQuestionaires;
        case "ascending":
            return AscendingAssessmentQuestionaires;
        case "downward":
            return DownwardAssessmentQuestionaires;
    
        default:
            throw new RangeError("Invalid value for 'assessmentType' property!");
    }
}) ;

const resolvedQuestionaireTypeTitle = computed(() => {
    let title;
    switch (props.assessmentType) {
        case "self":
            title =  `Auto-avaliação`;
			break;
        case "ascending":
            title =  "Avaliação Ascendente";
			break;
        case "downward":
            title =  "Avaliação Descendente";
			break;
    
        default:
            throw new RangeError("Invalid value for 'assessmentType' property!");
    }
    if(questionaire.value?.year) {
        title += ` (${questionaire.value.year})`
    }
    return title;
});

const resolvedAssessmentTargetName = computed(() => {
    let targetName = null;
    switch (props.assessmentType) {
        case "self":
            targetName = questionaire.value?.user?.name 
                            /* ??  sessionStore?.user?.name */;
            break;
            
        case "ascending":
            targetName = questionaire.value?.subject?.name;
            break;

        case "downward":
            targetName = questionaire.value?.subject_user?.name;
            break;
    
        default:
            throw new RangeError("Invalid value for 'assessmentType' property!");
    }

    return "Colaborador(a): " + (targetName ?? "Obtendo nome...")
});

const evaluationTypesList = [
    {
        key: "self",
        label: resolvedQuestionaireTypeTitle.value,
    },
    {
        key: "ascending",
        label: resolvedQuestionaireTypeTitle.value,
    },
    {
        key: "downward",
        label: resolvedQuestionaireTypeTitle.value,
    },
];

const formValues = ref({
    id: null,
    type: evaluationTypesList?.find((t) => t.key == props.assessmentType) ?? null,
    mode: validationMode.value,
    year: null,
    subject_user_id: null,
    answers: {},
});

const usersList = ref([]);

const questionnaireSections = computed(() => {
    if (props.assessmentType === "ascending") {
        return [
            {
                key: "ascending",
                title: "Competências Pessoais",
                competencies: questionaire.value?.model?.competencies ?? [],
                indicatorField: "indicator_id",
                valueField: "score",
                ratingValueField: "value",
                supportsNotApplicable: true,
            },
        ];
    }

    return [
        {
            key: "technical",
            title: "Competências Técnicas",
            competencies: questionaire.value.technical_competencies ?? [],
            indicatorField: "indicator_id",
            valueField: "assessment_rating_option_id",
            ratingValueField: "id",
            supportsNotApplicable: false,
        },
        {
            key: "personal",
            title: "Competências Pessoais",
            competencies: questionaire.value.personal_competencies ?? [],
            indicatorField: "personal_competency_indicator_id",
            valueField: "assessment_rating_option_id",
            ratingValueField: "id",
            supportsNotApplicable: false,
        },
        {
            key: "objectives",
            title: "Objetivos",
            competencies: questionaire.value.objectives ?? [],
            indicatorField: "objective_indicator_id",
            valueField: "assessment_rating_option_id",
            ratingValueField: "id",
            supportsNotApplicable: false,
        },
    ].filter((section) =>
        section.key !== "objectives" || section.competencies.length > 0
    );
});

function answerKey(section, indicator) {
    return `${section.key}:${indicator.id}`;
}

function initializeFormValues() {
    const answers = {};

    for (const section of questionnaireSections.value) {
        for (const competency of section.competencies) {
            for (const indicator of competency.indicators ?? []) {
                const answer = {
                    [section.indicatorField]: indicator.id,
                    [section.valueField]:
                        section.valueField === "score"
                            ? indicator.answer?.score ?? null
                            : indicator.assessment_rating_option_id ?? null,
                };

                if (section.supportsNotApplicable) {
                    answer.is_not_applicable =
                        indicator.answer?.is_not_applicable ?? null;
                }

                answers[answerKey(section, indicator)] = answer;
            }
        }
    }

    

    formValues.value = {
        id: questionaire.value?.id ?? null,
        type: props.assessmentType ?? null,
        year: questionaire.value?.year ?? null,
        subject_user_id: questionaire.value?.subject?.id 
                            ?? questionaire.value?.evaluator?.id
                            ?? questionaire.value?.subject_user?.id
                            ?? null,
        answers,
    };
}



function resolveCompetencyTitle(competencyKey) {
    switch (competencyKey) {
        case "competencies":
        case "personal_competencies":
            return "Competências Pessoais";

        case "technical_competencies":
            return "Competências Técnicas";

        case "objectives":
            return "Objectivos";
    
        default:
            throw new RangeError("Invalid value for 'assessmentType' property!");
    }
}

const possibleCompetencyTypeKeys = computed(() => {
    switch (props.assessmentType) {
        case "ascending":
            return ["competencies"];
            
        case "downward":
        case "self":
            return [
                "technical_competencies",
                "personal_competencies",
                "objectives"
            ];
    
        default:
            throw new RangeError("Invalid value for 'assessmentType' property!");
    }
})


async function fetchQuestionaire() {
    
    if(!props.assessmentModel?.id && !props.assessmentId) {
        return;
    }
    const modelId = props.assessmentModel?.id ?? props.assessmentId;
    
    isLoadingAssessmentModel.value = true;

    try {
        const response = await resolvedAssessmentApi.value.show(modelId);
        questionaire.value = response?.data ?? {};

        // TODO: FIXME: remove this later just a fallback for dev server to try to fill 
        // questionaire to be tested.
        if (!questionaire.value) {
            
        }
        initializeFormValues();
        if(props.assessmentType !== "self" && formValues.values?.type !== "self") {

            usersList.value = [
                {
                    id: questionaire.value?.subject?.id 
                        ?? questionaire.value?.evaluator?.id
                        ?? questionaire.value?.subject_user?.id
                        ?? null,
    
                    name: questionaire.value?.subject?.name 
                            ?? questionaire.value?.evaluator?.name
                            ?? questionaire.value?.subject_user?.name
                            ?? null
                }
            ];
        }
        else {
            
            usersList.value = [
                {
                    // id: sessionStore?.user?.id,
                    // name: sessionStore?.user?.name,
                    id: questionaire.value?.user?.id,
                    name: questionaire.value?.user?.name,
                }

            ];

        }
        formValues.value.subject_user_id = usersList.value[0].id;
        // alert for closed evaluation
        if(questionaire.value?.status === "submitted") {
            // alert for ascending evaluation
            if (questionaire.value?.user_is_subject && !questionaire.value?.user_is_evaluator) {
                alertInfo.value = {
                    type: "info",
                    title: "Avaliação como Supervisor(a)",
                    text: "Esta avaliação foi feita por um(a) Colaborador(a) em relação ao seu desempenho.",
                    variant: "flat",
                }
            }
            // alert for self-evaluation
            else if (questionaire.value?.user_is_subject && questionaire.value?.user_is_evaluator) {
                alertInfo.value = {
                    type: "info",
                    title: "Auto-avaliação do seu desempenho",
                    text: "Esta avaliação foi feita por si em relação ao seu desempenho.",
                    variant: "flat",
                }
            }
            // alert for downward evaluation
            else if(!questionaire.value?.user_is_subject && questionaire.value?.user_is_evaluator) {
                alertInfo.value = {
                    type: "info",
                    title: "Avaliação do seu desempenho",
                    text: "Esta avaliação foi feita pelo(a) seu Supervisor(a) em relação ao seu desempenho.",
                    variant: "flat",
                }
            }
            else {

                alertInfo.value = {
                    type: "info",
                    title: "Processo de Avaliação Concluído",
                    text: "Esta avaliação já foi submetida e não pode ser alterada.",
                    variant: "flat",
                }
            }
        } 
        else {
            alertInfo.value = {
                type: "warning",
                title: "Avaliação em Progresso",
                text: "Este processo de Avaliação está em progresso.",
                variant: "flat",
            }
        }
        
    } catch (error) {
        if (error.status === 404) {
            const list = await resolvedAssessmentApi.value.index({status: "draft", limit:1, with_competencies: 1, locale_code: "pt", with_competency_indicators: 1})
            questionaire.value = list?.data?.data?.[0] 
                                    ?? list?.data?.[0]
                                    ?? null;

            if(!questionaire.value) {
                throw new Error("Currently no Ascending assessments in 'draft' status found. Please make sure you have run the seeder(s).")
            }
            initializeFormValues();
            usersList.value = [
                {
                    id: questionaire.value?.subject?.id 
                        ?? questionaire.value?.evaluator?.id
                        ?? questionaire.value?.subject_user?.id
                        ?? null,

                    name: questionaire.value?.subject?.name 
                            ?? questionaire.value?.evaluator?.name
                            ?? questionaire.value?.subject_user?.name
                            ?? null
                }
            ]
            return;
        }
        console.error(error);

        alertInfo.value = {
            type: "error",
            title: `${error?.response?.statusText ?? error?.code ?? 'Erro'}`,
            text: `${error?.response?.data?.message ?? error?.message}${error?.options?.cause ? ' - ' + error?.options?.cause : ''}`,
        }
        throw error;
        
    } finally {
        isLoadingAssessmentModel.value = false;
    }
}

async function fetchRatingOptions() {
    isLoadingRatingOptions.value = true;

    try {
        
        const response = await AssessmentModels.ratingOptions();
        const ratings = Array.isArray(response?.data?.data)
                    ? response?.data?.data
                    : (
                        Array.isArray(response?.data)
                        ? response?.data
                        : []
                    )
                    ;
        ratingOptions.value = ratings?.map((r) => {
            switch (props.assessmentType) {
                case "self":
                    return {
                        id: r.id,
                        assessment_rating_option_id: r.id,
                        value: r.value,
                        name: r?.self_assessment_label ?? "Opção sem nome"
                    };
                case "ascending":
                    return {
                        id: r.id,
                        assessment_rating_option_id: r.id,
                        value: r.value,
                        name: r?.ascending_label ?? "Opção sem nome"
                    };
                case "downward":
                    
                    return {
                        id: r.id,
                        assessment_rating_option_id: r.id,
                        value: r.value,
                        name: r?.downward_label ?? "Opção sem nome"
                    };
            
                default:
                    throw RangeError(`Unsupported value for assessmentType property: '${props.assessmentType}'.`)
                    break;
            }
        })

        if(props.assessmentType === "ascending") {
            ratingOptions.value = ratingOptions.value?.filter((r) => r.value <= 5);
        }

        // console.log(ratingOptions.value);
    } catch (error) {
        
    } finally {
        isLoadingRatingOptions.value = false;
    }
}

function resolveFormValues(mode) {

    const payload = {

    };

    if(mode === "draft") {

    } else {
        payload = {...formValues.value}
    }

    return payload;
}

function answerRule(section, indicator) {
    return () => {
        if (validationMode.value === "draft") {
            return true;
        }

        const answer = formValues.value.answers[
            answerKey(section, indicator)
        ];

        if (
            answer.is_not_applicable
            || answer[section.valueField] !== null
        ) {
            return true;
        }

        return "Selecione uma classificação ou marque Não aplicável.";
    };
}


async function validate(mode = "draft") {
    validationMode.value = mode;

    await nextTick();

    const result = await form.value.validate();

    return result.valid;
}

async function submitFromDialog(_dialog) {
    return submit(validationMode.value);
}

async function submit(mode = "draft") {
    alertInfo.value = {
        type: null,
        title: null,
        message: null,
    };

    isSubmitting.value = true;
    validationMode.value = mode;
    formValues.value.mode = mode;
    const payload = formValues.value;
    // console.log(payload);
    
    
    try {
        if (!await validate(mode)) {
            let failedValidationMessage = "Falhou a validação do formulário."

            if (mode !== "draft") {
                failedValidationMessage += " Todas as questões são obrigatórias a não ser que tenha escolhido a opção 'Não aplicável'."
            }
            failedValidationMessage += " Verifique as mensagens de erro em cada campo.";
            alertInfo.value = {
                type: "error",
                title: "Erro de Validação",
                text: failedValidationMessage,
            };
            if(!props.standalone) {
                throw new Error(failedValidationMessage);
            }
            return false;
        }
        const response = await resolvedAssessmentApi.value.update(payload.id, payload);
        
        if(response.status === 200) {
            alertInfo.value = {
                type: "success",
                title: "Sucesso",
                text: mode === "draft"
                        ? "Rascunho da avaliação guardado com sucesso!"
                        : "Avaliação atualizada e submetida com sucesso!",

                variant: mode === "draft"
                            ? null
                            : "flat",
            }

            questionaire.value.status = response?.data?.status;
        }
        return response;
       
        
    } catch (error) {
        console.error(error);
        alertInfo.value = {
            type: "error",
            title: "Erro",
            text: error?.toString() ?? String(error),
        };
        throw error;
    } finally {
        isSubmitting.value = false;
    }
}

onBeforeMount(() => {
    fetchRatingOptions();
    fetchQuestionaire();
}); 

onMounted(() => {

});


</script>

<style scoped>
.indicator-rating-group-option.enabled :deep(.v-input__control > .v-label) {
    color: #000;
    opacity: 1;
}
</style>